import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useRunOfShowSummaryStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalL,
    alignItems: 'center',
  },
  metric: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    fontSize: fontScale.body,
  },
  metricValue: {
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground1,
  },
  metricLabel: {
    color: tokens.colorNeutralForeground3,
  },
  metricLarge: {
    color: tokens.colorPaletteRedForeground1,
  },
});
